export const weekDays = [
  { label: "S", value: 0 },
  { label: "M", value: 1 },
  { label: "T", value: 2 },
  { label: "W", value: 3 },
  { label: "T", value: 4 },
  { label: "F", value: 5 },
  { label: "S", value: 6 },
];

export const timeZones = [
  { label: "UTC", value: "UTC" },
  { label: "Europe/Istanbul", value: "Europe/Istanbul" },
  { label: "America/New_York", value: "America/New_York" },
  { label: "Asia/Kolkata", value: "Asia/Kolkata" },
  { label: "Asia/Tokyo", value: "Asia/Tokyo" },
  { label: "Australia/Sydney", value: "Australia/Sydney" },
  { label: "Europe/London", value: "Europe/London" },
  { label: "America/Los_Angeles", value: "America/Los_Angeles" },
  { label: "Europe/Berlin", value: "Europe/Berlin" },
  { label: "Asia/Dubai", value: "Asia/Dubai" },
];
